import { render } from "./links.vue?vue&type=template&id=0e0d0964&scoped=true"
import script from "./links.vue?vue&type=script&lang=js"
export * from "./links.vue?vue&type=script&lang=js"

import "./links.vue?vue&type=style&index=0&id=0e0d0964&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0d0964"]])

export default __exports__